import { Component, Input, Output, EventEmitter} from '@angular/core'

@Component({
  selector: 'app-st-button-back-to-top',
  templateUrl: './st-button-back-to-top.component.html',
  styleUrls: ['./st-button-back-to-top.component.scss'],
  standalone: false
})
export class StButtonBackToTopComponent {

  @Input()
  idVal: string = 'buttonId';

  @Input()
  label = 'Back to Top';

  @Output()
  onClick = new EventEmitter<Event>();

  public scrollToTop(): void {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
  }
}
